// extracted by mini-css-extract-plugin
export default {"StyledReceipt":"final_StyledReceipt__ypuZS"};